import { RESERVED_ERROR_CODES } from "@cervval.js/common/src/errors/errors";
import { Lang } from "@cervval.js/common/src/i18n/languages";
import { i18n } from "./i18n";

/** CTR Line Proxy Errors 4000 - 4099 */
export enum LINE_PROXY_ERRORS {
    RESERVED = RESERVED_ERROR_CODES, // * You can check all reserved codes here
    NOT_FOUND = 4000,
    DISPOSED = 4001,
    MISSING_DATA = 4002,
    INVALID_SAE_DSP_FORMAT = 4003,
    INACTIVE_DSP = 4004
}

/** Get all line proxy error messages */
export function getLineProxyErrorMessages(lang?: Lang): Record<Exclude<LINE_PROXY_ERRORS, LINE_PROXY_ERRORS.RESERVED>, string> {
    return i18n(lang);
}